export default {
  typeEventLabel: state => (typeEventValue) => {
    if (!Array.isArray(state.listTypeEvents) || !typeEventValue) return null;

    const { label = null } = state.listTypeEvents
      .find(type => type.value === typeEventValue) || {};

    return label;
  },
};



// WEBPACK FOOTER //
// ./node_modules/@intelipost-modules/secure-analytic/features/logs/pages/tracking/store/getters.js